import DisclosureTrigger from './disclosureTrigger.component';

export default DisclosureTrigger;
